import { LabelKey, Label } from "../model/Label.js";

export class Table {
    public rows: string[] = [];


    public row(...values: string[]): void {
        var datas: string = "";
        for (var i = 0; i < values.length; ++i) {
            datas += `<td class="e5-table__data" data-index="${i}">${e5.Text.escapeHtml(values[i])}</td>`;
        }
        this.rows.push(`<tr class="e5-table__row">${datas}</tr>`);
    }

    public label(label: LabelKey, value: string): void {
        this.row(Label.text(label), value);
    }

    public toString(): string {
        if (this.rows.length === 0) {
            return "";
        }
        return `<table class="e5-table">
                    <tbody>
                        ${this.rows.join("")}
                    </tbody>
                </table>`;
    }
}